// This file is automatically generated. Do not edit manually.

import { CustomerOrderLine } from "src/api/generated/erp/db/types/tables/customerOrderLine";
import { ObjectAttributeValueWithFieldId } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithFieldId";
import { StockPartConfigurationService_AvailableStockConfiguration } from "src/api/generated/erp/sales/customerOrder/service/stockPartConfigurationService";
import { IsoDateString } from "src/types/dateTime";
import { ObjectAttributeField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeField";
import { ObjectAttribute } from "src/api/generated/erp/db/types/tables/objectAttribute";
import { CustomerOrder } from "src/api/generated/erp/db/types/tables/customerOrder";
import { CustomerOrderLineView } from "src/api/generated/erp/db/types/tables/customerOrderLineView";
import { ProductionLine } from "src/api/generated/erp/db/types/tables/productionLine";
import { VatCode } from "src/api/generated/erp/db/types/tables/vatCode";
import { AcquisitionMethod } from "src/api/generated/erp/db/types/enums/acquisitionMethod";
import { ConfigurationDefaultPricingMethod } from "src/api/generated/erp/db/types/enums/configurationDefaultPricingMethod";
import { IsoDateTimeString } from "src/types/dateTime";
import { SalesPartViewPartType } from "src/api/generated/erp/db/types/enums/salesPartViewPartType";
import { SalesPartType } from "src/api/generated/erp/db/types/enums/salesPartType";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CustomerOrderLineFormApi {
	export async function getFormInitData(args: {
		customerOrderId: number;
		customerOrderLineId: number | null | undefined;
		parentLineId: number | null | undefined;
		copySourceCustomerOrderLineId?: number | null | undefined;
	}): Promise<CustomerOrderLineFormApi_InitData> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/getFormInitData",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				customerOrderLineId: args.customerOrderLineId,
				parentLineId: args.parentLineId,
				copySourceCustomerOrderLineId: args.copySourceCustomerOrderLineId,
			},
		});
		return response as CustomerOrderLineFormApi_InitData;
	}

	export async function getShouldConfigureBeforeInsert(args: {
		customerOrderId: number;
		salesPartId: number;
	}): Promise<boolean> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/getShouldConfigureBeforeInsert",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				salesPartId: args.salesPartId,
			},
		});
		return response as boolean;
	}

	export async function insert(args: {
		customerOrderLine: CustomerOrderLine;
		attributes?: Array<ObjectAttributeValueWithFieldId>;
		stockPartConfigurationId?: number | null | undefined;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/insert",
			method: "POST",
			data: {
				customerOrderLine: args.customerOrderLine,
				attributes: args.attributes,
				stockPartConfigurationId: args.stockPartConfigurationId,
			},
		});
		return response as number;
	}

	export async function getAvailableStockConfigurations(args: {
		customerOrderId: number;
		salesPartId: number;
		salesQuantityAsSalesUnits: number;
	}): Promise<Array<StockPartConfigurationService_AvailableStockConfiguration>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/getAvailableStockConfigurations",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				salesPartId: args.salesPartId,
				salesQuantityAsSalesUnits: args.salesQuantityAsSalesUnits,
			},
		});
		return response as Array<StockPartConfigurationService_AvailableStockConfiguration>;
	}

	export async function update(args: {
		customerOrderLine: CustomerOrderLine;
		updateAcquisitionObjectDates: boolean;
		attributes?: Array<ObjectAttributeValueWithFieldId>;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/update",
			method: "POST",
			data: {
				customerOrderLine: args.customerOrderLine,
				updateAcquisitionObjectDates: args.updateAcquisitionObjectDates,
				attributes: args.attributes,
			},
		});
		return response as void;
	}

	export async function getSalesPartOptions(args: {
		customerOrderId: number;
		searchQuery: string;
		currentSelection: number | null | undefined;
	}): Promise<Array<CustomerOrderLineFormApi_SalesPartDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/getSalesPartOptions",
			method: "POST",
			data: {
				customerOrderId: args.customerOrderId,
				searchQuery: args.searchQuery,
				currentSelection: args.currentSelection,
			},
		});
		return response as Array<CustomerOrderLineFormApi_SalesPartDto>;
	}

	export async function getSalesPartDefaultPrice(args: {
		salesPartId: number;
		customerOrderId: number;
		withVat: boolean;
		vatCodeId: number;
		plannedDeliveryDate: IsoDateString;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderLine/getSalesPartDefaultPrice",
			method: "POST",
			data: {
				salesPartId: args.salesPartId,
				customerOrderId: args.customerOrderId,
				withVat: args.withVat,
				vatCodeId: args.vatCodeId,
				plannedDeliveryDate: args.plannedDeliveryDate,
			},
		});
		return response as number;
	}
}

export const CustomerOrderLineFormApi_InitData_AcquisitionObjectStateValues = [
	"NOT_EXISTS",
	"INITIAL",
	"SHOP_ORDER_PLANNED",
	"PURCHASE_ORDER_RELEASED",
] as const;

export type CustomerOrderLineFormApi_InitData_AcquisitionObjectState =
	(typeof CustomerOrderLineFormApi_InitData_AcquisitionObjectStateValues)[number];

export interface CustomerOrderLineFormApi_InitData {
	acquisitionObjectState: CustomerOrderLineFormApi_InitData_AcquisitionObjectState;
	attributeFields: Array<ObjectAttributeField>;
	attributeValues: Array<ObjectAttribute>;
	currencyCode: string;
	customerOrder: CustomerOrder;
	customerOrderLine: CustomerOrderLineView | null | undefined;
	defaultLineNumber: number;
	domesticCurrencyCode: string;
	parentLine: CustomerOrderLine | null | undefined;
	productionLineOptions: Array<ProductionLine>;
	salesPart: CustomerOrderLineFormApi_SalesPartDto | null | undefined;
	vatCodeOptions: Array<VatCode>;
}

export interface CustomerOrderLineFormApi_SalesPartDto {
	availableQuantity: number | null | undefined;
	acquisitionMethod: AcquisitionMethod | null | undefined;
	active: boolean;
	automaticDelivery: boolean;
	canBeUsedOnCustomerOfferLine: boolean;
	canBeUsedOnCustomerOrderLine: boolean;
	capacityQuantity: number | null | undefined;
	catalogPartId: number | null | undefined;
	configurationDefaultPricingMethod: ConfigurationDefaultPricingMethod;
	currencyCode: string;
	currencyId: number;
	estimatedLeadtime: number | null | undefined;
	hasTemplateConfiguration: boolean;
	isAdjustment: boolean;
	isDefault: boolean;
	lastUpdated: IsoDateTimeString;
	partActive: boolean | null | undefined;
	partAggregateOnShopOrder: boolean;
	partCategory: string | null | undefined;
	partCategoryDescription: string | null | undefined;
	partDefaultProductionLineId: number | null | undefined;
	partDescription_1: string | null | undefined;
	partDescription_2: string | null | undefined;
	partId: number | null | undefined;
	partIsConfigurable: boolean | null | undefined;
	partNo: string | null | undefined;
	partRemark: string | null | undefined;
	partType: SalesPartViewPartType | null | undefined;
	partUnit: string | null | undefined;
	partUnitId: number | null | undefined;
	partWeight: number | null | undefined;
	priceFactor: number;
	priceGroupName: string | null | undefined;
	salesFactor: number;
	salesPartCategoryId: number | null | undefined;
	salesPartCategoryName: string | null | undefined;
	salesPartDescription: string;
	salesPartId: number;
	salesPartLongName: string | null | undefined;
	salesPartNo: string;
	salesPartPriceGroupId: number | null | undefined;
	salesPartType: SalesPartType;
	salesPrice: number;
	salesPriceUnit: string;
	salesPriceUnitId: number;
	salesUnit: string;
	salesUnitId: number;
	siteId: number;
	siteName: string;
	sitePartCategoryId: number | null | undefined;
	standardCost: number | null | undefined;
	standardCostAsPriceUnits: number | null | undefined;
	vatCodeId: number;
	vatCodeName: string;
}
